import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Clinic Info */}
          <div className="lg:col-span-2">
            <h3 className="heading-playfair text-2xl font-semibold mb-4 text-white">
              Sourires Saint-Bruno
            </h3>
            <p className="text-slate-300 mb-2">Denturologistes</p>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              Confection de prothèses complètes, partielles et sur implants. 
              Une approche humaine, douce et rassurante pour retrouver le plaisir de sourire.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contact</h4>
            <div className="space-y-4">
              <a
                href="tel:450-441-3636"
                className="flex items-start gap-3 text-slate-300 hover:text-[#D4AF37] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>450-441-3636</span>
              </a>
              <div className="flex items-start gap-3 text-slate-300">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <address className="not-italic text-sm leading-relaxed">
                  1501, place de l'Hôtel-de-Ville<br />
                  Saint-Bruno-de-Montarville<br />
                  Québec J3V 5Y6
                </address>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Heures</h4>
            <div className="flex items-start gap-3 text-slate-300">
              <Clock className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <div className="text-sm leading-relaxed">
                <p>Vendredis</p>
                <p>Un mercredi sur deux (soirée)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} Sourires Saint-Bruno Denturologistes. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <Link
                to="/contact"
                className="text-slate-400 hover:text-white text-sm transition-colors"
                data-testid="footer-contact-link"
              >
                Contact
              </Link>
              <Link
                to="/services"
                className="text-slate-400 hover:text-white text-sm transition-colors"
                data-testid="footer-services-link"
              >
                Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
